(function () {
  function setActiveThumb(thumbs, mediaId) {
    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', isActive);
      if (thumb.hasAttribute('aria-current')) {
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      }
    });
  }

  function initDesktopGallery(root) {
    const desktop = root.querySelector('.pebble-product-media__desktop');
    if (!desktop || desktop.dataset.pebbleDesktopInit === 'true') return;

    const thumbs = desktop.querySelectorAll('[data-pebble-grid-thumb]');
    const slides = desktop.querySelectorAll('.pebble-product-media__main-grid .pebble-product-media__slide');
    if (!thumbs.length || !slides.length) return;

    desktop.dataset.pebbleDesktopInit = 'true';

    const slideByMediaId = (mediaId) =>
      desktop.querySelector('.pebble-product-media__main-grid .pebble-product-media__slide[data-media-id="' + mediaId + '"]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = slideByMediaId(thumb.dataset.mediaId);
        if (!target) return;

        setActiveThumb(thumbs, thumb.dataset.mediaId);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.55) return;
            setActiveThumb(thumbs, entry.target.dataset.mediaId);
          });
        },
        { root: null, threshold: [0.55, 0.75], rootMargin: '-20% 0px -20% 0px' }
      );

      slides.forEach((slide) => observer.observe(slide));
    }
  }

  function initMobileGallery(root) {
    const mobile = root.querySelector('.pebble-product-media__mobile');
    if (!mobile || mobile.dataset.pebbleMobileInit === 'true') return;

    const mainSwiperEl = mobile.querySelector('.pebble-product-media__carousel');
    const thumbsEl = mobile.querySelector('.pebble-product-media__mobile-thumbs');
    if (!mainSwiperEl) return;

    const getSlideIndexByMediaId = (swiper, mediaId) => {
      if (!swiper || !mediaId) return -1;
      for (let i = 0; i < swiper.slides.length; i++) {
        const slide = swiper.slides[i];
        if (!slide || slide.classList.contains('swiper-slide-duplicate')) continue;
        if (slide.getAttribute('data-media-id') === mediaId) return i;
      }
      return -1;
    };

    const connectThumbs = () => {
      const mainSwiper = mainSwiperEl.swiper;
      if (!mainSwiper) return;

      mobile.dataset.pebbleMobileInit = 'true';

      // Évite les slides dupliquées (loop) qui cassent le zoom lightbox
      // et décalent l'index (2e image au lieu de la 1re).
      try {
        if (mainSwiper.params && mainSwiper.params.loop) {
          mainSwiper.params.loop = false;
          if (typeof mainSwiper.loopDestroy === 'function') mainSwiper.loopDestroy();
          mainSwiper.update();
        }
        const firstIndex = getSlideIndexByMediaId(
          mainSwiper,
          mainSwiperEl.querySelector('.swiper-slide[data-index="0"]')?.getAttribute('data-media-id')
        );
        if (firstIndex >= 0 && mainSwiper.activeIndex !== firstIndex) {
          mainSwiper.slideTo(firstIndex, 0);
        }
      } catch (error) {
        /* ignore */
      }

      const mobileThumbs = mobile.querySelectorAll('.pebble-product-media__mobile-thumb');

      const syncThumbState = () => {
        const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
        if (!activeSlide) return;
        const mediaId = activeSlide.getAttribute('data-media-id');
        mobileThumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
        });
      };

      mainSwiper.on('slideChange', syncThumbState);

      mobileThumbs.forEach((thumb) => {
        if (thumb.dataset.pebbleThumbBound === 'true') return;
        thumb.dataset.pebbleThumbBound = 'true';

        let lastNavAt = 0;
        const goToThumb = (event) => {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }
          }
          const now = Date.now();
          if (now - lastNavAt < 250) return;
          lastNavAt = now;

          const mediaId = thumb.getAttribute('data-media-id');
          const slideIndex = getSlideIndexByMediaId(mainSwiper, mediaId);
          if (slideIndex < 0) return;
          mainSwiper.slideTo(slideIndex);
          syncThumbState();
        };

        thumb.addEventListener('click', goToThumb, true);
        thumb.addEventListener(
          'pointerup',
          (event) => {
            if (event.pointerType === 'mouse') return;
            goToThumb(event);
          },
          true
        );
      });

      if (thumbsEl && thumbsEl.dataset.pebbleThumbsGuard !== 'true') {
        thumbsEl.dataset.pebbleThumbsGuard = 'true';
        thumbsEl.addEventListener(
          'click',
          (event) => {
            if (!event.target.closest('.pebble-product-media__mobile-thumb')) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );
      }

      syncThumbState();
    };

    if (mainSwiperEl.swiper) {
      connectThumbs();
    } else {
      mainSwiperEl.addEventListener('swiper:ready', connectThumbs, { once: true });
      setTimeout(connectThumbs, 800);
    }
  }

  function syncVariantMedia(root, mediaId) {
    if (!mediaId) return;

    const desktop = root.querySelector('[data-pebble-desktop-main]');
    if (desktop) {
      const slide = desktop.querySelector(
        '.pebble-product-media__main-grid .pebble-product-media__slide[data-media-id="' + mediaId + '"]'
      );
      const thumbs = desktop.querySelectorAll('[data-pebble-grid-thumb]');
      if (slide) {
        setActiveThumb(thumbs, mediaId);
        if (window.matchMedia('(min-width: 780px)').matches) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    const mobileCarousel = root.querySelector('.pebble-product-media__carousel');
    if (mobileCarousel?.swiper && window.matchMedia('(max-width: 779px)').matches) {
      const slides = mobileCarousel.querySelectorAll('.swiper-slide[data-media-id]');
      slides.forEach((slide, index) => {
        if (slide.dataset.mediaId === mediaId) {
          mobileCarousel.swiper.slideTo(index);
        }
      });
    }
  }

  function bindVariantMedia(root) {
    const sectionId = root.dataset.sectionId;
    const variantRadios = document.querySelector('variant-radios[data-section="' + sectionId + '"]');
    if (!variantRadios || variantRadios.dataset.pebbleMediaBound === 'true') return;

    variantRadios.dataset.pebbleMediaBound = 'true';

    let userChangedVariant = false;
    const handleVariantMedia = () => {
      if (!userChangedVariant) return;
      const formInput = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
      if (!formInput) return;

      const variantData = variantRadios.querySelector('#VariantJson-' + sectionId);
      if (!variantData) return;

      try {
        const variants = JSON.parse(variantData.textContent);
        const variant = variants.find((entry) => String(entry.id) === String(formInput.value));
        if (variant?.featured_media?.id) {
          syncVariantMedia(root, sectionId + '-' + variant.featured_media.id);
        } else if (variant?.featured_image?.id) {
          syncVariantMedia(root, sectionId + '-' + variant.featured_image.id);
        }
      } catch (error) {
        return;
      }
    };

    variantRadios.addEventListener('change', () => {
      userChangedVariant = true;
      handleVariantMedia();
    });
    variantRadios.addEventListener('variantRendered', handleVariantMedia);
  }

  function initPebbleProductMedia(root) {
    if (!root || root.dataset.pebbleMediaInit === 'true') return;
    root.dataset.pebbleMediaInit = 'true';
    initDesktopGallery(root);
    initMobileGallery(root);
    bindVariantMedia(root);
  }

  function boot(context) {
    (context || document).querySelectorAll('[data-pebble-product-media]').forEach(initPebbleProductMedia);
  }

  function safeCloseProductModal(modal) {
    if (!modal) return;
    try {
      const wrapper = modal.querySelector('.product__media-wrapper');
      if (wrapper?.swiper && typeof wrapper.swiper.destroy === 'function') {
        wrapper.swiper.destroy(true, true);
      }
    } catch (error) {
      /* ignore broken cloned swiper */
    }

    try {
      const content = modal.querySelector('.product-media-modal__content');
      if (content) content.innerHTML = '';
    } catch (error) {
      /* ignore */
    }

    modal.removeAttribute('open');
    document.body.classList.remove('overflow-hidden-fixed');
    const lockedTop = document.body.style.top;
    document.body.style.top = '';
    if (lockedTop) {
      window.scrollTo({ left: 0, top: -1 * parseInt(lockedTop || '0', 10) || 0, behavior: 'instant' });
    }
  }

  function hydrateLightboxImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('.image-container').forEach((box) => {
      box.classList.add('visible');
    });
    scope.querySelectorAll('img').forEach((img) => {
      img.classList.add('visible');
      img.loading = 'eager';
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');

      const dataSrc = img.getAttribute('data-src');
      const dataSrcset = img.getAttribute('data-srcset');
      if (dataSrc) img.src = dataSrc;
      if (dataSrcset) img.setAttribute('srcset', dataSrcset);

      let srcset = img.getAttribute('srcset') || '';
      if (srcset) {
        const parts = srcset
          .split(',')
          .map((part) => part.trim())
          .filter((part) => /\s\d+[wx]$/.test(part));
        if (parts.length) img.setAttribute('srcset', parts.join(', '));
        else img.removeAttribute('srcset');
      }
      img.setAttribute('sizes', '100vw');

      if (!img.complete || img.naturalWidth === 0) {
        const src = img.getAttribute('src');
        if (src) img.src = src;
      }

      try {
        if (window.theme?.utils?.lazyBackgroundObserver) {
          theme.utils.lazyBackgroundObserver.observe(img);
        }
      } catch (error) {
        /* ignore */
      }
    });
  }

  function bindLightboxSlideHydrate(wrapper) {
    if (!wrapper || wrapper.dataset.pebbleHydrateBound === 'true') return;

    const attach = () => {
      const swiper = wrapper.swiper;
      if (!swiper || wrapper.dataset.pebbleHydrateBound === 'true') return;
      wrapper.dataset.pebbleHydrateBound = 'true';
      const run = () => {
        const slides = swiper.slides || [];
        const index = swiper.activeIndex || 0;
        [slides[index - 1], slides[index], slides[index + 1]].forEach((slide) => {
          if (slide) hydrateLightboxImages(slide);
        });
      };
      swiper.on('slideChange', run);
      swiper.on('slideChangeTransitionStart', run);
      run();
    };

    if (wrapper.swiper) {
      attach();
      return;
    }
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (wrapper.swiper || tries > 40) {
        clearInterval(timer);
        attach();
      }
    }, 50);
  }

  function patchProductModalHide() {
    const Proto = customElements.get('product-modal')?.prototype;
    if (!Proto || Proto.__pebbleHidePatched) return;
    Proto.__pebbleHidePatched = true;

    const originalHide = Proto.hide;
    Proto.hide = function patchedHide() {
      try {
        if (typeof originalHide === 'function') {
          // Avoid crash: cloned wrapper can have .swiper-initialized without .swiper
          const wrapper = this.querySelector('.product__media-wrapper.swiper-initialized');
          if (wrapper && !wrapper.swiper) {
            wrapper.classList.remove('swiper-initialized');
          }
          return originalHide.apply(this, arguments);
        }
      } catch (error) {
        safeCloseProductModal(this);
      }
    };
  }

  function findModalSlideIndex(wrapper, mediaId, sectionId) {
    if (!wrapper || !mediaId) return -1;
    const prefixed = sectionId ? String(sectionId) + '-' + String(mediaId) : null;
    const slides = wrapper.swiper?.slides
      ? Array.from(wrapper.swiper.slides)
      : Array.from(wrapper.querySelectorAll('.product__media-item, .swiper-slide'));

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      if (!slide || slide.classList.contains('swiper-slide-duplicate')) continue;
      const slideMediaId = slide.getAttribute('data-media-id');
      if (slideMediaId === prefixed || slideMediaId === String(mediaId)) return i;
      if (slide.querySelector('[data-media-id="' + mediaId + '"]')) return i;
    }
    return -1;
  }

  function prepareClonedLightboxWrapper(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
    wrapper.removeAttribute('style');
    delete wrapper.swiper;

    wrapper.querySelectorAll('.swiper-slide-duplicate').forEach((dup) => dup.remove());

    const swiperWrapper = wrapper.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.removeAttribute('style');
      swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.classList.remove(
          'swiper-slide-active',
          'swiper-slide-next',
          'swiper-slide-prev',
          'swiper-slide-fully-visible',
          'swiper-slide-visible'
        );
        slide.removeAttribute('style');
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('role');
      });
    }

    wrapper.querySelectorAll('.swiper-notification').forEach((el) => el.remove());
  }

  function patchProductModalShowActive() {
    const Proto = customElements.get('product-modal')?.prototype;
    if (!Proto || Proto.__pebbleShowActivePatched) return;
    Proto.__pebbleShowActivePatched = true;

    const originalLoadContent = Proto.loadContent;
    Proto.loadContent = function patchedLoadContent() {
      const source = this.closest('.product-section')?.querySelector(
        '.product__media--main.product__media-wrapper'
      );
      if (source && this.modalContent) {
        this.modalContent.innerHTML = '';
        this.modalContent.appendChild(source.cloneNode(true));
      } else if (typeof originalLoadContent === 'function') {
        originalLoadContent.apply(this, arguments);
      }
      const wrapper = this.querySelector('.product__media-wrapper');
      prepareClonedLightboxWrapper(wrapper);
      hydrateLightboxImages(this);
      bindLightboxSlideHydrate(wrapper);
    };

    Proto.showActiveMedia = async function patchedShowActiveMedia() {
      let mediaId = null;
      try {
        mediaId = this.getMediaIdFromOpener();
      } catch (error) {
        mediaId = null;
      }

      const wrapper = this.querySelector('.product__media-wrapper');
      if (!wrapper || !mediaId) return;

      hydrateLightboxImages(this);
      bindLightboxSlideHydrate(wrapper);

      const sectionId = this.dataset.section;
      const prefixed = sectionId ? sectionId + '-' + mediaId : mediaId;

      this.querySelectorAll('.product__media-item.active, [data-media-id].active').forEach((el) => {
        el.classList.remove('active');
      });

      const targetSlide =
        wrapper.querySelector(
          '.product__media-item[data-media-id="' + prefixed + '"]:not(.swiper-slide-duplicate)'
        ) ||
        wrapper.querySelector('[data-media-id="' + prefixed + '"]:not(.swiper-slide-duplicate)') ||
        wrapper.querySelector('[data-media-id="' + mediaId + '"]');

      if (targetSlide) targetSlide.classList.add('active');

      const isDesktop = document.documentElement.clientWidth >= 780;
      const usesSwiper = wrapper.getAttribute('data-active') === 'true' || !isDesktop;

      if (isDesktop && !usesSwiper) {
        if (targetSlide && typeof targetSlide.scrollIntoView === 'function') {
          targetSlide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        return;
      }

      if (typeof this.waitForSwiperInitialization === 'function') {
        try {
          await this.waitForSwiperInitialization(wrapper);
        } catch (error) {
          /* ignore */
        }
      }

      // Fallback: wait briefly if swiper not ready yet
      if (!wrapper.swiper) {
        await new Promise((resolve) => {
          let tries = 0;
          const timer = setInterval(() => {
            tries += 1;
            if (wrapper.swiper || tries > 30) {
              clearInterval(timer);
              resolve();
            }
          }, 50);
        });
      }

      if (!wrapper.swiper) return;

      let index = findModalSlideIndex(wrapper, mediaId, sectionId);
      if (index < 0 && targetSlide) {
        index = Array.from(wrapper.swiper.slides || []).indexOf(targetSlide);
      }
      if (index < 0) return;

      if (typeof wrapper.swiper.slideToLoop === 'function' && wrapper.swiper.params?.loop) {
        const realIndex = wrapper.swiper.slides[index]?.getAttribute('data-swiper-slide-index');
        if (realIndex != null) {
          wrapper.swiper.slideToLoop(parseInt(realIndex, 10), 0);
          return;
        }
      }
      wrapper.swiper.slideTo(index, 0);
    };
  }

  function bindLightboxContain() {
    if (document.documentElement.dataset.pebbleLightboxBound === 'true') return;
    document.documentElement.dataset.pebbleLightboxBound = 'true';

    const patchAll = () => {
      patchProductModalHide();
      patchProductModalShowActive();
    };

    patchAll();
    if (customElements.get('product-modal')) {
      patchAll();
    } else {
      customElements.whenDefined('product-modal').then(patchAll);
    }

    const containOpenModal = () => {
      const modal = document.querySelector('product-modal[open]');
      if (!modal) return;
      const content = modal.querySelector('.product-media-modal__content');
      if (content) content.scrollTop = 0;

      const wrapper = modal.querySelector('.product__media-wrapper');
      if (wrapper && wrapper.classList.contains('swiper-initialized') && !wrapper.swiper) {
        wrapper.classList.remove('swiper-initialized');
      }

      if (window.matchMedia('(min-width: 780px)').matches) {
        const desktopWrapper = modal.querySelector('.product__media-wrapper[data-active="false"]');
        if (!desktopWrapper) return;
        const active = desktopWrapper.querySelector('.product__media-item.active');
        if (!active) {
          const first = desktopWrapper.querySelector('.product__media-item');
          if (first) first.classList.add('active');
        }
      }
    };

    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('.product__media-toggle')) {
          requestAnimationFrame(() => setTimeout(containOpenModal, 30));
          return;
        }

        const modal = document.querySelector('product-modal[open]');
        if (!modal) return;

        if (event.target.closest('.product-media-modal__close')) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof modal.hide === 'function') {
            try {
              modal.hide();
            } catch (error) {
              safeCloseProductModal(modal);
            }
          } else {
            safeCloseProductModal(modal);
          }
          return;
        }

        // Clic sur le fond (pas sur l'image) → fermer
        if (event.target === modal || event.target.classList?.contains('product-media-modal__dialog')) {
          event.preventDefault();
          try {
            modal.hide();
          } catch (error) {
            safeCloseProductModal(modal);
          }
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const modal = document.querySelector('product-modal[open]');
      if (!modal) return;
      event.preventDefault();
      try {
        modal.hide();
      } catch (error) {
        safeCloseProductModal(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      boot();
      bindLightboxContain();
    });
  } else {
    boot();
    bindLightboxContain();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
